import React from 'react';
import PropTypes from 'prop-types';

import environmentNames from '../../../../../../../qti/environmentNames';
import { t } from '../../../../../../../services/i18nService';

import styles from '../../ckeditorWrapper.scss';

const DrawingToolCkeditorModalWrapper = (props) => {
    let DrawingTool;
    if (process.env.NODE_ENV !== environmentNames.UNIT_TESTING) {
        DrawingTool = require('../../../plugins/drawing/DrawingTool').default;
    }

    if (!DrawingTool) {
        return null;
    }

    return (<div className={styles.drawingToolWrapper}>
        <h2>{t('essay.drawing.modal.title')}: { props.title }</h2>
        <DrawingTool {...props} />
    </div>);
};

DrawingToolCkeditorModalWrapper.propTypes = {
    title: PropTypes.string.isRequired,
};

export default DrawingToolCkeditorModalWrapper;
